<template>
  <!-- partial -->
  <div class="main-panel">
    <div class="content-wrapper dashboard-shell">
      <div class="row">
        <div class="col-12 grid-margin">
          <div class="card cardplay solicitud-shell">
            <div class="card-body solicitud-card-body">
              <form-tag-beneficiarios @ClienteEditEvent="submitHandler" name="cliente" event="clienteEditEvent">
                <div class="row dashboard-header g-3 align-items-center mb-4">
                  <div v-if="this.store.aprobacion?.id>0" class="col-12 col-lg-7">
                    <h4 class="dashboard-title mb-2">
                      Actualizacion de Solicitante de Crédito
                    </h4>
                    <p class="solicitud-subtitle mb-0">
                      Se necesita actualizar los datos del solicitante de crédito, por favor verifique que la información sea correcta.
                      <br />
                      En caso de que sean correctos, haga clic en el botón "Actualizar y Validar" para guardar los cambios.
                    </p>
                  </div>
                  <div v-else class="col-12 col-lg-7">
                    <h4 class="dashboard-title mb-0">
                      Nuevo Solicitante de Crédito 
                    </h4>
                  </div>

                  <div v-if="this.idCliente > 0" class="col-12 col-lg-5 d-flex justify-content-lg-end align-items-center gap-2">
                    <span class="solicitud-badge">{{ this.store.aprobacion?.id > 0 ? 'Validación pendiente' : 'Edición activa' }}</span>
                    <button
                      v-if="this.store.aprobacion?.id <= 0"
                      type="button"
                      style="color:white;"
                      class="btn btn-success solicitud-main-btn"
                      @click="realizarSolicitud"
                    >
                      Realizar solicitud
                    </button>
                    <button v-if=" this.store.aprobacion?.id > 0" type="submit" style="color:white;" class="btn btn-primary solicitud-main-btn">
                      Actualizar y Validar
                    </button>
                    <button v-else type="submit" style="color:white;" class="btn btn-primary solicitud-main-btn">
                      Actualizar
                    </button>
                  </div>


                </div>

                <div class="accordion solicitud-accordion" id="accordionPanelsStayOpenExample">
                  <div class="accordion-item">
                    <h2 class="accordion-header" id="panelsStayOpen-headingOne">
                      <button class="accordion-button" type="button" data-bs-toggle="collapse"
                        data-bs-target="#panelsStayOpen-collapseOne" aria-expanded="true"
                        aria-controls="panelsStayOpen-collapseOne">
                        <div class="col-6">Datos Personales del Solicitante</div>
                        <div id="validar-1" class="d-flex justify-content-end me-3" style="width: 100%"></div>
                      </button>
                    </h2>
                    <div id="panelsStayOpen-collapseOne" class="accordion-collapse collapse show"
                      aria-labelledby="panelsStayOpen-headingOne">
                      <div class="accordion-body">
                        <div class="row datos-personales-row">
                          <div class="col-md-6 datos-personales-col">
                            <div class="form-group row">
                              <label class="col-sm-3 col-form-label">Nombres</label>
                              <div class="col-sm-9 d-flex align-items-center">
                                <input v-model="cliente.nombres" type="text" :required="required()" class="form-control"
                                  value="cliente.nombres" name="nombres" />
                              </div>
                            </div>
                            <div class="form-group row">
                              <label class="col-sm-3 col-form-label">Apellidos</label>
                              <div class="col-sm-9 d-flex align-items-center">
                                <text-input v-model="cliente.apellidos" type="text" id="apellido" :required="required()"
                                  name="apellidos"></text-input>
                              </div>
                            </div>
                            <div class="form-group row">
                              <label class="col-sm-3 col-form-label">DNI</label>
                              <div class="col-sm-9 d-flex align-items-center">
                                <input :required="required()" id="dni" v-model="dni" @input="formatInput" minlength="15"
                                  maxlength="15" placeholder="Ejemplo: 0801-1998-01234" class="form-control mt-2 mb-2"
                                  name="dni" />
                              </div>
                              <div v-if="this.mensajeDni" class="row d-flex justify-content-center align-items-center">
                                <div class="col-4"></div>
                                <div class="col-8 alert alert-danger text-center" role="alert">
                                  {{ this.mensajeDni }} 😲
                                </div>
                              </div>
                            </div>
                            <div class="form-group row">
                              <label class="col-sm-3 col-form-label">RTN</label>
                              <div class="col-sm-9 d-flex align-items-center">
                                <text-input v-model="cliente.rtn" :required="required()" type="text" name="rtn" id="rtn"
                                  minlength="14" maxlength="14" inputmode="numeric" pattern="[0-9]{14}"></text-input>
                              </div>
                            </div>
                            <div class="form-group row">
                              <label class="col-sm-3 col-form-label">Lugar de Nacimiento</label>
                              <div class="col-sm-9 d-flex align-items-center">
                                <text-input v-model="cliente.lugarNacimiento"  type="text"
                                  name="lugar-nacimiento" id="lugarNacimiento"></text-input>
                              </div>
                            </div>
                            <div class="form-group row">
                              <label class="col-sm-3 col-form-label">Sexo</label>
                              <div class="col-sm-9 d-flex align-items-center">
                                <select v-model="cliente.sexo" name="sexo" id="sexo" class="form-select"
                                  aria-label="Default select example">
                                  <option value="MASCULINO">MASCULINO</option>
                                  <option value="FEMENINO">FEMENINO</option>
                                </select>
                              </div>
                            </div>
                            <div v-if="this.cliente.edad" class="form-group row">
                              <label class="col-sm-3 col-form-label">Edad: {{ this.cliente.edad }}</label>
                            </div>
                            <div class="form-group row">
                              <label class="col-sm-3 col-form-label">Fecha de Nacimiento</label>
                              <div class="col-sm-9 d-flex align-items-center">
                                <input v-model="cliente.fechaNacimiento" type="date"  class="form-control" :required="required()"
                                  placeholder="dd/mm/yyyy" name="fecha-nacimiento" />
                              </div>
                            </div>
                          </div>

                          <div class="col-md-6 datos-personales-col">
                            <div class="form-group row foto-cliente-field">
                              <label class="col-sm-3 col-form-label">Foto cliente</label>
                              <div class="col-sm-9 d-flex align-items-center gap-3 flex-wrap">
                                <div class="foto-cliente-preview">
                                  <img v-if="fotoClientePreviewUrl" :src="fotoClientePreviewUrl" alt="Foto cliente" />
                                  <i v-else class="fa-solid fa-user"></i>
                                </div>
                                <div class="foto-cliente-actions">
                                  <input class="form-control" type="file" accept="image/*"
                                    @change="handleFotoClienteChange">
                                  <small>JPG o PNG, maximo 5 MB.</small>
                                </div>
                              </div>
                            </div>
                            <div class="form-group row">
                              <label class="col-sm-3 col-form-label">Estado Civil</label>
                              <div class="col-sm-9 d-flex align-items-center">
                                <select id="estadoCivil" name="estado-civil" v-model="cliente.estadoCivil"
                                  class="form-select" aria-label="Default select example" :required="required()">
                                  <option value="SOLTERO(A)">SOLTERO(A)</option>
                                  <option value="CASADO(A)">CASADO(A)</option>
                                  <option value="UNION LIBRE">UNION LIBRE</option>
                                  <option value="SEPARADO(A)">SEPARADO(A)</option>
                                  <option value="DIVORCIADO(A)">DIVORCIADO(A)</option>
                                  <option value="VIUDO(A)">VIUDO(A)</option>
                                </select>
                              </div>
                            </div>
                            <div class="form-group row">
                              <label class="col-sm-3 col-form-label">Correo Electronico</label>
                              <div class="col-sm-9 d-flex align-items-center">
                                <text-input v-model="cliente.email" id="correo" type="email" :required="required()"
                                  name="email"></text-input>
                              </div>
                            </div>
                            <div class="form-group row">
                              <label class="col-sm-3 col-form-label">Celular</label>
                              <div class="col-sm-9">
                                <div class="d-flex align-items-center gap-2">
                                  <text-input v-model="cliente.celular" id="celular" type="text" :required="required()"
                                    name="celular"></text-input>
                                  <button v-if="cliente.id > 0" type="button" class="btn btn-outline-secondary celular-history-btn"
                                    @click="toggleCelularHistorial">
                                    {{ mostrarHistorialCelular ? 'Ocultar' : 'Historial' }}
                                  </button>
                                </div>
                                <div v-if="mostrarHistorialCelular" class="celular-history-panel">
                                  <div v-if="celularHistorialCargando" class="celular-history-empty">Cargando historial...</div>
                                  <div v-else-if="celularHistorial.length === 0" class="celular-history-empty">Sin cambios registrados.</div>
                                  <div v-else class="celular-history-list">
                                    <div v-for="item in celularHistorial" :key="item.idHistorial" class="celular-history-item">
                                      <div class="celular-history-date">{{ formatHistorialDate(item.fechaModificacion) }}</div>
                                      <div class="celular-history-values">
                                        <span>{{ item.valorAnterior || 'Sin valor' }}</span>
                                        <i class="fa-solid fa-arrow-right"></i>
                                        <strong>{{ item.valorNuevo || 'Sin valor' }}</strong>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div v-if="false" class="row">
                          <div class="col-md-6">
                            <div class="form-group row">
                              <label class="col-sm-3 col-form-label">Nombre del Banco</label>
                              <div class="col-sm-9 d-flex align-items-center">
                                <select class="form-select" v-model="cliente.nombreBanco" id="nombre-banco"
                                  :value="cliente.nombreBanco" name="nombre-banco" :required="required()">
                                  <option value="Banco Atlantica">Banco Atlantida</option>
                                  <option value="BAC">BAC</option>
                                  <option value="Banco Ficohsa">Banco Ficohsa</option>
                                  <option value="Banco de Occidente">Banco de Occidente</option>
                                  <option value="Banco Davivienda">Banco Davivienda</option>
                                  <option value="Banco Promerica">Banco Promerica</option>
                                  <option value="Banco Lafise">Banco Lafise</option>
                                  <option value="Banco de los Trabajadores">Banco de los Trabajadores</option>
                                  <option value="Banco Azteca">Banco Azteca</option>
                                  <option value="Banco BANHCAFE">Banco BANHCAFE</option>
                                  <option value="Banco FICENSA">Banco FICENSA</option>
                                  <option value="Banco de Desarrollo Rural Honduras">Banco de Desarrollo Rural Honduras
                                  </option>
                                  <option value="Banco Popular"> Banco Popular</option>
                                  <option value="Banco Banpais"> Banco BANPAIS</option>

                                  <option value="Otro">Otro</option>
                                </select>
                              </div>
                            </div>
                          </div>
                          <div class="col-md-6">
                            <div class="form-group row">
                              <label class="col-sm-3 col-form-label">Número de Cuenta del Banco</label>
                              <div class="col-sm-9 d-flex align-items-center">
                                <text-input v-model="cliente.noCuentaBanco" id="no-cuenta-cuenta" type="text" :required="required()"
                                  name="no-cuenta-banco"></text-input>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="wrapper">
                   
                           

                  </div>
                  <div class="accordion-item">
                    <h2 class="accordion-header" id="panelsStayOpen-headingTwo">
                      <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                        data-bs-target="#panelsStayOpen-collapseTwo" aria-expanded="false"
                        aria-controls="panelsStayOpen-collapseTwo">
                        <div class="col-6">Datos Domiciliares del Solicitante</div>
                        <div id="validar-2" class="d-flex justify-content-end me-3" style="width: 100%"></div>
                      </button>
                    </h2>
                    <div id="panelsStayOpen-collapseTwo" class="accordion-collapse collapse"
                      aria-labelledby="panelsStayOpen-headingTwo">
                      <div class="accordion-body">
                        <div class="row">
                          <div class="col-md-6">
                            <div class="form-group row">
                              <label class="col-sm-3 col-form-label">Departamento</label>
                              <div class="col-sm-9 d-flex align-items-center">
                                <!--  <text-input v-model="cliente.departamento" type="text" :value="cliente.departamento"
                                  name="departamento"></text-input> -->

                                <select v-model="cliente.departamento" id="departamento" name="departamento"
                                  class="form-select" :required="required()">
                                  <option v-for="departamentos in departamentos" :key="departamentos.idDepartamento"
                                    :value="departamentos?.nombre">
                                    {{ departamentos?.nombre }}
                                  </option>
                                </select>
                              </div>
                            </div>
                          </div>
                          <div class="col-md-6">
                            <div class="form-group row">
                              <label class="col-sm-3 col-form-label">Municipio</label>
                              <div class="col-sm-9 d-flex align-items-center">
                                <select v-model="cliente.municipio" id="municipio" name="municipio" class="form-select" :required="required()">
                                  <option v-for="municipios in municipios" :key="municipios.id"
                                    :value="municipios?.nombre">
                                    {{ municipios?.nombre }}
                                  </option>
                                </select>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-md-6">
                            <div class="form-group row">
                              <label class="col-sm-3 col-form-label">Colonia/Barrio/Aldea</label>
                              <div class="col-sm-9 d-flex align-items-center">
                                <text-input v-model="cliente.colonia" type="text" name="colonia" :required="required()"></text-input>
                              </div>
                            </div>
                          </div>
                          <div class="col-md-6">
                            <div class="form-group row">
                              <label class="col-sm-3 col-form-label">Calle</label> 
                              <div class="col-sm-9 d-flex align-items-center">
                                <text-input v-model="cliente.calle"  type="text" name="calle"></text-input>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-md-6">
                            <div class="form-group row">
                              <label class="col-sm-3 col-form-label">Avenida</label>
                              <div class="col-sm-9 d-flex align-items-center">
                                <text-input v-model="cliente.avenida" type="text"  name="avenida"></text-input>
                              </div>
                            </div>
                          </div>
                          <div class="col-md-6">
                            <div class="form-group row">
                              <label class="col-sm-3 col-form-label">Bloque</label>
                              <div class="col-sm-9 d-flex align-items-center">
                                <text-input v-model="cliente.bloque" type="text"  name="bloque"></text-input>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-md-6">
                            <div class="form-group row">
                              <label class="col-sm-3 col-form-label">Casa No.</label>
                              <div class="col-sm-9 d-flex align-items-center">
                                <text-input v-model="cliente.noCasa" type="text" :required="required()" name="no-casa"></text-input>
                              </div>
                            </div>
                          </div>
                          <div class="col-md-6">
                            <div class="form-group row">
                              <label class="col-sm-3 col-form-label">Punto de referencia</label>
                              <div class="col-sm-9 d-flex align-items-center">
                                <text-input id="punto-referencia" v-model="cliente.puntoReferencia" type="text" :required="required()"
                                  name="punto-referencia"></text-input>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-md-6">
                            <div class="form-group row">
                              <label class="col-sm-3 col-form-label">Tipo de vivienda</label>
                              <div class="col-sm-9 d-flex align-items-center">
                                <select v-model="cliente.tipoVivienda" name="tipoVivienda" class="form-select"
                                  aria-label="Default select example">
                                  <option value="PROPIA">PROPIA</option>
                                  <option value="ALQUILADA">ALQUILADA</option>
                                  <option value="FAMILIAR">FAMILIAR</option>
                                  <option value="PAGANDOLA">PAGANDOLA</option>
                                  <option value="PRESTADA">PRESTADA</option>
                                </select>
                              </div>
                            </div>
                          </div>
                          <div class="col-md-6">
 
                          </div>


                        </div>
                        <div v-if="this.cliente.tipoVivienda == `ALQUILADA` || this.cliente.tipoVivienda == `PAGANDOLA`" class="row">
                          <div v-if="this.cliente.tipoVivienda == `ALQUILADA` ||
                            this.cliente.tipoVivienda == `PAGANDOLA`
                          " class="col-md-6">
                            <div class="form-group row">
                              <label class="col-sm-3 col-form-label">Cuota de Vivienda</label>
                              <div class="col-sm-9 d-flex align-items-center">
                                <text-input require v-model="cliente.cuotaVivienda" type="text"
                                  name="cuota-vivienda"></text-input>
                              </div>
                            </div>
                          </div>
                          <div class="col-md-6">
                            <div class="form-group row">
                              <label class="col-sm-3 col-form-label">Si alquila: Nombre y teléfono del
                                propietario</label>
                              <div class="col-sm-9 d-flex align-items-center">
                                <text-input v-model="cliente.propietarioAlquila" type="text" :required="required()"
                                  name="propietario-alquila"></text-input>
                              </div>
                            </div>
                          </div>
                        </div>

                      </div>
                    </div>
                  </div>
                  <div class="accordion-item">
                    <h2 class="accordion-header" id="panelsStayOpen-headingFive">
                      <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                        data-bs-target="#panelsStayOpen-collapseFive" aria-expanded="false"
                        aria-controls="panelsStayOpen-collapseFour">
                        <div class="col-6">Georeferencias</div>
                        <div id="validar-4" class="d-flex justify-content-end me-3" style="width: 100%"></div>
                      </button>
                    </h2>
                    <div id="panelsStayOpen-collapseFive" class="accordion-collapse collapse"
                      aria-labelledby="panelsStayOpen-headingFive">
                      <div class="accordion-body">

                            
                       <h4 class="display-4">Domicilio:</h4> 
                            <GeolocalizacionComponent
                              v-model="cliente.referenciaGeografica"
                              :soloMapa="false"
                            />
                            <div class="d-flex align-items-center gap-2 mt-2 mb-2">
                              <input type="text" v-model="cliente.referenciaGeografica" readonly class="form-control" name="referenciaGeografica" />
                              <button v-if="cliente.id > 0" type="button" class="btn btn-outline-secondary celular-history-btn"
                                @click="toggleReferenciaGeograficaHistorial">
                                {{ mostrarHistorialReferenciaGeografica ? 'Ocultar' : 'Historial' }}
                              </button>
                            </div>
                            <div v-if="mostrarHistorialReferenciaGeografica" class="celular-history-panel">
                              <div v-if="referenciaGeograficaHistorialCargando" class="celular-history-empty">Cargando historial...</div>
                              <div v-else-if="referenciaGeograficaHistorial.length === 0" class="celular-history-empty">Sin cambios registrados.</div>
                              <div v-else class="celular-history-list">
                                <div v-for="item in referenciaGeograficaHistorial" :key="item.idHistorial" class="celular-history-item">
                                  <div class="celular-history-date">{{ formatHistorialDate(item.fechaModificacion) }}</div>
                                  <div class="celular-history-values">
                                    <span>{{ item.valorAnterior || 'Sin valor' }}</span>
                                    <i class="fa-solid fa-arrow-right"></i>
                                    <strong>{{ item.valorNuevo || 'Sin valor' }}</strong>
                                  </div>
                                </div>
                              </div>
                            </div>

                       <!--
                       <h4 class="display-4">Negocio:</h4> 
                            <GeolocalizacionComponent
                              v-model="cliente.referenciaGeograficaNegocio"
                              :soloMapa="false"
                            />
                            <input type="text" v-model="cliente.referenciaGeograficaNegocio" readonly class="form-control mt-2 mb-2" name="referenciaGeograficaNegocio" />
                       -->




                      </div>
                    </div>
                  </div>

                  <div class="accordion-item">
                    <h2 class="accordion-header" id="panelsStayOpen-headingSix">
                      <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                        data-bs-target="#panelsStayOpen-collapseSix" aria-expanded="false"
                        aria-controls="panelsStayOpen-collapseSix">
                        <div class="col-6">Historial Crediticio</div>
                        <div id="validar-4" class="d-flex justify-content-end me-3" style="width: 100%"></div>
                      </button>
                    </h2>
                    <div id="panelsStayOpen-collapseSix" class="accordion-collapse collapse"
                      aria-labelledby="panelsStayOpen-headingSix">
                      <div class="accordion-body">

                            
<div class="row g-3">
  <!-- Puntaje Equifax -->
  <div class="col-md-6">
    <label for="puntaje_equifax" class="form-label">Puntaje Equifax</label>
    <input
      id="puntaje_equifax"
      type="number"
      class="form-control"
      v-model="cliente.puntaje_equifax"
    />
  </div>

  <!-- Ingresos Mensuales -->
  <div class="col-md-6">
    <label for="ingresos_mensuales" class="form-label">Ingresos Mensuales</label>
    <input
      id="ingresos_mensuales"
      type="number"
      step="0.01"
      class="form-control"
      v-model="cliente.ingresos_mensuales"
    />
  </div>

  <!-- DTI -->
  <div class="col-md-6">
    <label for="dti" class="form-label">Deuda: Total cuotas mensuales</label>
    <input
      id="dti"
      type="number"
      class="form-control"
      v-model="cliente.dti"
    />
  </div>

  <!-- Antigüedad -->
  <div class="col-md-6">
    <label for="antiguedad" class="form-label">Antigüedad</label>
    <div class="input-group">
      <input
        id="antiguedad"
        type="number"
        min="0"
        class="form-control"
        placeholder="Cantidad"
        v-model="cliente.antiguedad_cantidad"
      />
     
    </div>
  </div>

  <!-- Garantía -->
  <div class="col-md-6">
  <label for="garantia" class="form-label">Garantía:</label>
   <select class="form-select" v-model="cliente.garantia">
        <option value="Mixta">Mixta</option>
        <option value="Alta liquidez">Alta liquidez(Hipotecaria)</option>
        <option value="Media">Media</option>
        <option value="Baja">Baja</option>
        <option value="No hay">No hay</option>
      </select>
</div>

  <!-- comportamiento -->
  <div class="col-md-6">
      
  
        <label for="comportamiento" class="form-label">Comportamiento: Selecciona un valor del 0 al 5</label>
        

    <div class="row d-flex justify-content-center align-items-center">

      <div class="col-md-6">

        <input
        id="comportamiento"
        type="number"
        min="0"
        max="10"
        class="form-control"
        placeholder="Cantidad"
        v-model="cliente.comportamiento"
        />
      </div>
      <div class="col-md-6">
        
        <p v-if="cliente.comportamiento >= 8 && cliente.comportamiento <=10">Excelente Conducta</p>
        <p v-else-if="cliente.comportamiento >= 4 && cliente.comportamiento <=7">Aceptable</p>
        <p v-else-if="cliente.comportamiento >= 0 && cliente.comportamiento <=3">Riesgoso</p>
        <p v-else class="text-danger">Número Invalido</p>
        
      </div>
    </div>
  </div>

  <!-- Puntaje de Crédito Visual -->
  
  <div class="row">

  </div>

  <div class="col-md-12">
    Detalles {{ this.score }}
    <DetalleCliente
      :puntaje_equifax="cliente.puntaje_equifax"
      :ingresos_mensuales="cliente.ingresos_mensuales"
      :dti="cliente.dti"
      :antiguedad_cantidad="cliente.antiguedad_cantidad"
      :antiguedad_unidad="cliente.antiguedad_unidad"
      :garantia="cliente.garantia"
      :comportamiento="cliente.comportamiento"
      currency="Lps"
      v-model:score="score"
    />


  </div>
  
</div>



                      </div>
                    </div>
                  </div>
                  <div v-if="false" class="accordion-item">
                    <h2 class="accordion-header" id="panelsStayOpen-headingThree">
                      <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                        data-bs-target="#panelsStayOpen-collapseThree" aria-expanded="false"
                        aria-controls="panelsStayOpen-collapseThree">
                        <div class="col-6">Destino del Crédito</div>
                        <div id="validar-3" class="d-flex justify-content-end me-3" style="width: 100%"></div>

                      </button>
                    </h2>
                    <div id="panelsStayOpen-collapseThree" class="accordion-collapse collapse"
                      aria-labelledby="panelsStayOpen-headingThree">
                      <div class="accordion-body">
                        <div class="row">
                          <div class="col-md-6">
                            <div class="form-group row">
                              <label class="col-sm-3 col-form-label">Destino</label>
                              <div class="col-sm-9 d-flex align-items-center">
                                <select v-model="cliente.destino" name="destino" class="form-select"
                                  aria-label="Default select example">
                                  <option value="produccion">Producción</option>
                                  <option value="comercio">Comercio</option>
                                  <option value="servicios">Servicios</option>
                                  <option value="turismo">Turismo</option>
                                </select>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <input type="submit" v-if="this.entraNavbar" class="btn btn-primary mt-3" value="Enviar" />
                </div>
              </form-tag-beneficiarios>
            </div>

        
          </div>
        </div>
      </div>

    </div>
    <!-- content-wrapper ends -->
    <!-- partial:../../partials/_footer.html -->
    <footer class="footer">
      <div class="d-sm-flex justify-content-center justify-content-sm-between">
        <span class="text-muted text-center text-sm-left d-block d-sm-inline-block">Copyright ©
          AXCC 2023</span>

      </div>
    </footer>
    <!-- partial -->
  </div>
</template>

<script>
import Security from "../security";
import TextInput from "@/components/forms/Text-Input.vue";
import { solicitudCompleta } from '../solicitud';
import router from '@/router';
import FormTagBeneficiarios from '../forms/FormTagBeneficiarios.vue'
import direccionData from './direccionData.json';
import GeolocalizacionComponent from './GeolocalizacionComponent.vue';
import { geoMaps } from "../geoMaps";
import Swal from "sweetalert2";
import { store } from '../store';
import DetalleCliente from '../score/ScoreDetails.vue';


export default {
  name: "NuevoSolicitante",
  data() {
    return {
      refStatus: '',
      geoMaps,
      store,
      departamento: {},
      direccionData: [],
      municipiosData: [],
      selectedDepartamento: '',
      solicitudCompleta,
      entraNavbar: false,
      fechaNacimiento: "",
      idCliente: 0,
      noReferencias: 1,
      dni: "",
      mensajeDni: "",
      score: 0,
      fotoClienteFile: null,
      fotoClientePreviewUrl: "",
      fotoClienteObjectUrl: "",
      mostrarHistorialCelular: false,
      celularHistorial: [],
      celularHistorialCargando: false,
      celularHistorialCargado: false,
      mostrarHistorialReferenciaGeografica: false,
      referenciaGeograficaHistorial: [],
      referenciaGeograficaHistorialCargando: false,
      referenciaGeograficaHistorialCargado: false,

      cliente: {
        id: 0,
        nombres: "",
        apellidos: "",
        rtn: "",
        lugarNacimiento: "",
        sexo: "",
        edad: "",
        estadoCivil: "",
        email: "",
        celular: "",
        fechaNacimiento: "",

        departamento: "",
        municipio: "",
        colonia: "",
        calle: "",
        avenida: "",
        bloque: "",
        noCasa: "",
        puntoReferencia: "",
        tipoVivienda: "",
        cuotaVivienda: "",
        propietarioAlquila: "",
        referenciaGeografica: "",
        referenciaGeograficaNegocio: "",

        estado: "",

        puntaje_equifax: 0,
        ingresos_mensuales: "",
        dti: 0,
        antiguedad_unidad: "",
        antiguedad_cantidad: "",
        garantia: "",
        comportamiento: "",

      },
      departamentos: [],
      municipios: [],
      departamentoSeleccionado: null,
      DetalleCliente,
    };
  },
  mounted() {
    // document.querySelector(".ownModalBack").addEventListener("click", () => {
    //   const modal = document.querySelector(".ownModal");
    //   modal.classList.remove("ownModalActive");
    // }),
      // document.getElementById("ver-mas-ref-geo").addEventListener("click", () => {
      //   const modal = document.querySelector(".ownModal");
      //   modal.classList.add("ownModalActive");
      // })
    // document.getElementById("refStatus").disabled = true;

  },
  beforeMount() {
    Security.requireToken();
    this.departamentos = direccionData[0].departamentos
    this.idCliente = this.$route.params.solicitanteId
    // Obtener Cliente por edit is id > 0
    if (this.$route.params.solicitanteId > 0) {
      //editing a solicitante
      fetch(
        process.env.VUE_APP_API_URL +
        "/admin/clientes/" +
        this.$route.params.solicitanteId,
        Security.requestOptions("")
      )
        .then((response) => response.json())
        .then((data) => {
          if (data.error) {
            this.$emit("error", data.message);
          } else {
            console.log("Data: ", data);
            // this.geoMaps.coordenates = data.data.referenciaGeografica
            this.cliente = data.data;
            this.normalizeClientePersonalData();
            this.dni = data.data.dni;
            this.cliente.estado = data.data.estado;
            this.cargarFotoCliente(data.data.id);
          }
        });
    }
    if (this.$route.params.solicitanteId === 'nuevo') {
      this.entraNavbar = true
    }
  },
  components: {
    "text-input": TextInput,
    FormTagBeneficiarios,
    GeolocalizacionComponent,
    // CreditScoreGauge,
    DetalleCliente,
  },

  beforeUnmount() {
    if (this.fotoClienteObjectUrl) {
      URL.revokeObjectURL(this.fotoClienteObjectUrl);
    }
    if (this.fotoClientePreviewUrl?.startsWith("blob:")) {
      URL.revokeObjectURL(this.fotoClientePreviewUrl);
    }
  },

  watch: {
    'cliente.nombres': function (value) {
      const upperValue = this.toUppercaseText(value);
      if (value !== upperValue) {
        this.cliente.nombres = upperValue;
      }
    },

    'cliente.apellidos': function (value) {
      const upperValue = this.toUppercaseText(value);
      if (value !== upperValue) {
        this.cliente.apellidos = upperValue;
      }
    },

    'cliente.rtn': function (value) {
      const rtn = this.onlyDigits(value).slice(0, 14);
      if (value !== rtn) {
        this.cliente.rtn = rtn;
      }
    },

    'cliente.lugarNacimiento': function (value) {
      const upperValue = this.toUppercaseText(value);
      if (value !== upperValue) {
        this.cliente.lugarNacimiento = upperValue;
      }
    },

    'cliente.sexo': function (value) {
      const sexo = this.normalizeSexo(value);
      if (value !== sexo) {
        this.cliente.sexo = sexo;
      }
    },

    'cliente.estadoCivil': function (value) {
      const estadoCivil = this.normalizeEstadoCivil(value);
      if (value !== estadoCivil) {
        this.cliente.estadoCivil = estadoCivil;
      }
    },

    'cliente.email': function (value) {
      const email = this.normalizeEmail(value);
      if (value !== email) {
        this.cliente.email = email;
      }
    },

    'cliente.colonia': function (value) {
      this.setUppercaseClienteField("colonia", value);
    },

    'cliente.calle': function (value) {
      this.setUppercaseClienteField("calle", value);
    },

    'cliente.avenida': function (value) {
      this.setUppercaseClienteField("avenida", value);
    },

    'cliente.bloque': function (value) {
      this.setUppercaseClienteField("bloque", value);
    },

    'cliente.puntoReferencia': function (value) {
      this.setUppercaseClienteField("puntoReferencia", value);
    },

    'cliente.tipoVivienda': function (value) {
      const tipoVivienda = this.normalizeTipoVivienda(value);
      if (value !== tipoVivienda) {
        this.cliente.tipoVivienda = tipoVivienda;
      }
    },

    'cliente.fechaNacimiento': function (newVal) {
      // JSON.stringify(newVal);
      // Convierte la fecha de nacimiento en un objeto Date
      var fechaNacimiento = new Date(newVal);

      // Obtiene la fecha actual
      var fechaActual = new Date();

      // Calcula la diferencia en milisegundos entre las fechas
      var diferencia = fechaActual - fechaNacimiento;

      // Convierte la diferencia en milisegundos a años
      var edad = Math.floor(diferencia / (365.25 * 24 * 60 * 60 * 1000));

      this.cliente.edad = edad;
    },

    dni(dni) {
      // console.log(dni);

      if (
        Array.from(dni).length == 15 &&
        (this.$route.params.solicitanteId <= 0 || this.$route.params.solicitanteId == "nuevo")
      ) {
        let payload = dni?.replace(/-/g, "");

        // this.mensajeDni = dni
        fetch(
          `${process.env.VUE_APP_API_URL}/admin/clientes/existe`,
          Security.requestOptions(payload)
        )
          .then((response) => response.json())
          .then((data) => {
            if (data.error) {
              this.$emit("error", data.message);
            } else {
              this.$emit("success", "Solicitante Creado");
              // alert('Solicitante Creado');
              // router.push("/");
              dni = document.getElementById("dni");
              dni.classList.remove("is-invalid");
              if (data.message == "Existe") {
                // dni.classList.remove('was-validated')
                dni.classList.add("is-invalid");
                this.mensajeDni = "DNI Ya existe";
              } else {
                this.mensajeDni = "";
                dni = document.getElementById("dni");
                dni.classList.remove("is-invalid");
                dni.classList.add("was-validated");
              }
            }
          })
          .catch((error) => {
            this.$emit("error", error);
          });
      } else {
        this.mensajeDni = "";
        dni = document.getElementById("dni");
        dni.classList.remove("is-invalid");
        dni.classList.add("was-validated");
      }
    },
    'cliente.departamento': function (direccion) {
      const municipios = (this.departamentos.filter(departamento => departamento.nombre === direccion))[0]?.municipios
      this.municipios = JSON.parse(JSON.stringify(municipios ? municipios : ''))
    }
  },
  methods: {
    toUppercaseText(value) {
      return typeof value === "string" ? value.toUpperCase().trimStart() : value;
    },

    setUppercaseClienteField(field, value) {
      const upperValue = this.toUppercaseText(value);
      if (value !== upperValue) {
        this.cliente[field] = upperValue;
      }
    },

    onlyDigits(value) {
      return typeof value === "string" ? value.replace(/\D/g, "") : "";
    },

    normalizeSexo(value) {
      const upperValue = this.toUppercaseText(value);
      if (upperValue === "M") {
        return "MASCULINO";
      }
      if (upperValue === "F") {
        return "FEMENINO";
      }
      return upperValue;
    },

    normalizeEstadoCivil(value) {
      const upperValue = this.toUppercaseText(value);
      const estados = {
        SOLTERO: "SOLTERO(A)",
        "SOLTERO(A)": "SOLTERO(A)",
        CASADO: "CASADO(A)",
        "CASADO(A)": "CASADO(A)",
        UNION: "UNION LIBRE",
        "UNION LIBRE": "UNION LIBRE",
        SEPARADO: "SEPARADO(A)",
        "SEPARADO(A)": "SEPARADO(A)",
        DIVORCIADO: "DIVORCIADO(A)",
        "DIVORCIADO(A)": "DIVORCIADO(A)",
        VIUDO: "VIUDO(A)",
        "VIUDO(A)": "VIUDO(A)",
      };
      return estados[upperValue] || upperValue;
    },

    normalizeTipoVivienda(value) {
      const upperValue = this.toUppercaseText(value);
      const tipos = {
        PROPIA: "PROPIA",
        ALQUILADO: "ALQUILADA",
        ALQUILADA: "ALQUILADA",
        FAMILIAR: "FAMILIAR",
        PAGANDOLA: "PAGANDOLA",
        "PAGÁNDOLA": "PAGANDOLA",
        PRESTADA: "PRESTADA",
      };
      return tipos[upperValue] || upperValue;
    },

    normalizeEmail(value) {
      return typeof value === "string" ? value.trim().toLowerCase() : "";
    },

    normalizeClientePersonalData() {
      this.cliente.nombres = this.toUppercaseText(this.cliente.nombres);
      this.cliente.apellidos = this.toUppercaseText(this.cliente.apellidos);
      this.cliente.rtn = this.onlyDigits(this.cliente.rtn).slice(0, 14);
      this.cliente.lugarNacimiento = this.toUppercaseText(this.cliente.lugarNacimiento);
      this.cliente.sexo = this.normalizeSexo(this.cliente.sexo);
      this.cliente.estadoCivil = this.normalizeEstadoCivil(this.cliente.estadoCivil);
      this.cliente.email = this.normalizeEmail(this.cliente.email);
      this.cliente.colonia = this.toUppercaseText(this.cliente.colonia);
      this.cliente.calle = this.toUppercaseText(this.cliente.calle);
      this.cliente.avenida = this.toUppercaseText(this.cliente.avenida);
      this.cliente.bloque = this.toUppercaseText(this.cliente.bloque);
      this.cliente.puntoReferencia = this.toUppercaseText(this.cliente.puntoReferencia);
      this.cliente.tipoVivienda = this.normalizeTipoVivienda(this.cliente.tipoVivienda);
    },

    rtnValido() {
      return !this.cliente.rtn || this.cliente.rtn.length === 14;
    },

    emailValido() {
      if (!this.cliente.email) {
        return true;
      }
      return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(this.cliente.email);
    },

    required(){
      if (this. idCliente == 0 || this.idCliente == "nuevo" || this.store.aprobacion?.id>0) {
        return true
      } else {
        return false
      }
    },
    realizarSolicitud() {
      const dniCliente = (this.dni || this.cliente.dni || "").replace(/\D/g, "");

      if (dniCliente.length !== 13) {
        Swal.fire({
          icon: "error",
          title: "DNI invalido",
          text: "El cliente debe tener un DNI valido para realizar la solicitud.",
          confirmButtonText: "Leido",
        });
        return;
      }

      this.store.aprobacion.id = 0;
      this.store.aprobacion.validacion = true;
      this.solicitudCompleta.integrantes.splice(0);
      this.solicitudCompleta.dniIntegrantes.splice(0);
      this.solicitudCompleta.integranteSolicitud = 0;

      router.push({
        name: "NuevaSolicitud",
        params: { solicitudId: 0 },
        query: { dni: dniCliente, validado: "1" },
      });
    },
    verMasRefGeo(e) {
      e.preventDefault();
      const modal = document.querySelector(".ownModal");
      modal.classList.add("ownModalActive");
    },

    async toggleCelularHistorial() {
      this.mostrarHistorialCelular = !this.mostrarHistorialCelular;
      if (this.mostrarHistorialCelular && !this.celularHistorialCargado) {
        await this.cargarCelularHistorial();
      }
    },

    async cargarCelularHistorial() {
      if (!this.cliente.id) {
        return;
      }

      this.celularHistorialCargando = true;
      try {
        const response = await fetch(
          `${process.env.VUE_APP_API_URL}/admin/clientes/${this.cliente.id}/historial/celular`,
          Security.requestOptions({})
        );
        const data = await response.json();
        if (data.error) {
          this.$emit("error", data.message);
          return;
        }

        this.celularHistorial = data.data?.historial || [];
        this.celularHistorialCargado = true;
      } catch (error) {
        this.$emit("error", error);
      } finally {
        this.celularHistorialCargando = false;
      }
    },

    async toggleReferenciaGeograficaHistorial() {
      this.mostrarHistorialReferenciaGeografica = !this.mostrarHistorialReferenciaGeografica;
      if (this.mostrarHistorialReferenciaGeografica && !this.referenciaGeograficaHistorialCargado) {
        await this.cargarReferenciaGeograficaHistorial();
      }
    },

    async cargarReferenciaGeograficaHistorial() {
      if (!this.cliente.id) {
        return;
      }

      this.referenciaGeograficaHistorialCargando = true;
      try {
        const response = await fetch(
          `${process.env.VUE_APP_API_URL}/admin/clientes/${this.cliente.id}/historial/referencia-geografica`,
          Security.requestOptions({})
        );
        const data = await response.json();
        if (data.error) {
          this.$emit("error", data.message);
          return;
        }

        this.referenciaGeograficaHistorial = data.data?.historial || [];
        this.referenciaGeograficaHistorialCargado = true;
      } catch (error) {
        this.$emit("error", error);
      } finally {
        this.referenciaGeograficaHistorialCargando = false;
      }
    },

    formatHistorialDate(value) {
      if (!value) {
        return "";
      }

      return new Date(value).toLocaleString("es-HN", {
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
        hour: "2-digit",
        minute: "2-digit",
      });
    },


    submitHandler() {
      this.normalizeClientePersonalData();

      if (!this.rtnValido()) {
        Swal.fire({
          icon: "error",
          title: "RTN invalido",
          text: "El RTN debe tener exactamente 14 digitos.",
          confirmButtonText: "Leido",
        });
        return;
      }

      if (!this.emailValido()) {
        Swal.fire({
          icon: "error",
          title: "Correo invalido",
          text: "Ingrese un correo electronico valido.",
          confirmButtonText: "Leido",
        });
        return;
      }

      const payload = {
        id: this.cliente.id,
        nombres: this.cliente.nombres,
        apellidos: this.cliente.apellidos,
        dni: (this.dni).replace(/-/g, ""),
        rtn: this.cliente.rtn,
        lugarNacimiento: this.cliente.lugarNacimiento,
        sexo: this.cliente.sexo,
        edad: parseInt(this.cliente.edad, 10),
        // edad: this.cliente.edad,
        fechaNacimiento: this.cliente.fechaNacimiento,
        estadoCivil: this.cliente.estadoCivil,
        email: this.cliente.email,
        celular: this.cliente.celular,
        departamento: this.cliente.departamento,
        municipio: this.cliente.municipio,
        colonia: this.cliente.colonia,
        calle: this.cliente.calle,
        avenida: this.cliente.avenida,
        bloque: this.cliente.bloque,
        noCasa: this.cliente.noCasa,
        puntoReferencia: this.cliente.puntoReferencia,
        tipoVivienda: this.cliente.tipoVivienda,
        propietarioAlquila: this.cliente.propietarioAlquila,
        // cuotaVivienda: this.cliente.cuotaVivienda,
        cuotaVivienda: parseInt(this.cliente.cuotaVivienda, 10),
        referenciaGeografica: this.cliente.referenciaGeografica,
        referenciaGeograficaNegocio: this.cliente.referenciaGeograficaNegocio,

        idUsuario: Security.getUser()[0].user.id,
        estado: this.cliente.estado,

        puntaje_equifax: this.cliente.puntaje_equifax,
        ingresos_mensuales: parseInt(this.cliente.ingresos_mensuales,
          10),
        dti: parseInt(this.cliente.dti, 10),
        antiguedad_cantidad: parseInt(this.cliente.antiguedad_cantidad, 10),
        antiguedad_unidad: this.cliente.antiguedad_unidad,
        garantia: this.cliente.garantia,
        comportamiento: parseInt(this.cliente.comportamiento),

      };

      const esClienteEnAprobacion = Number(this.cliente.id) === Number(this.store.aprobacion?.id);
      let title;
      let text;
      if (esClienteEnAprobacion) {
        title='¿Estás Seguro de que deseas modificar y validar la información del cliente?'
        text = 'Seleccionando que Acepta, se guardaran y validaran la información del cliente como correcta.'
      }else{
        title='¿Estás Seguro de que deseas modificar la información del cliente?'
        text = ''
      }

      //Peticion Fetch
      Swal.fire({
        title: title,
        text: text,
        icon: 'success',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Guardar Cambios!'
      }).then((result) => {
        if (result.isConfirmed) {

          fetch(
            `${process.env.VUE_APP_API_URL}/admin/clientes/save`,
            Security.requestOptions(payload)
          )
            .then((response) => response.json())
            .then(async (data) => {
              if (data.error) {
                this.$emit("error", data.message);
              } else {
                if (data.message == "Existe") {
                  let identidad = document.getElementById("dni");

                  identidad.classList.add("is-invalid");
                  this.mensajeDni = "DNI Existente";
                  alert("El solicitante ya existe");
                } else {
                  const savedId = data.data?.id || this.cliente.id || payload.id;
                  payload.id = savedId
                  this.cliente.id = savedId
                  await this.guardarFotoClienteSiExiste(payload.id);
                  this.solicitudCompleta.integrantes.push(payload);
                  this.solicitudCompleta.dniIntegrantes.push(payload.id);

                  if (esClienteEnAprobacion) {
                    this.store.aprobacion.validacion = true
                    setTimeout(() => {
                      router.push("/solicitud/integrante/0");
                    }, 500);
                  }else{
                    window.location.reload();
                  }
                }
              }
            })
            .catch((error) => {
              this.$emit("error", error);
            });
        } 
      })



    },

    handleFotoClienteChange(event) {
      const file = event.target.files?.[0];
      if (!file) {
        return;
      }

      if (!file.type.startsWith("image/")) {
        Swal.fire({
          icon: "error",
          title: "Formato no permitido",
          text: "La foto cliente debe ser una imagen JPG o PNG.",
          confirmButtonText: "Leido",
        });
        event.target.value = "";
        return;
      }

      if (file.size > 5 * 1024 * 1024) {
        Swal.fire({
          icon: "error",
          title: "Archivo muy grande",
          text: "La foto cliente no debe superar 5 MB.",
          confirmButtonText: "Leido",
        });
        event.target.value = "";
        return;
      }

      this.fotoClienteFile = file;
      if (this.fotoClienteObjectUrl) {
        URL.revokeObjectURL(this.fotoClienteObjectUrl);
      }
      this.fotoClienteObjectUrl = URL.createObjectURL(file);
      this.fotoClientePreviewUrl = this.fotoClienteObjectUrl;
    },

    async cargarFotoCliente(idCliente) {
      if (!idCliente || idCliente === "nuevo") {
        return;
      }

      try {
        const url = await Security.authenticatedBlobUrl(`/admin/clientes/foto/${idCliente}`);
        if (this.fotoClientePreviewUrl?.startsWith("blob:")) {
          URL.revokeObjectURL(this.fotoClientePreviewUrl);
        }
        this.fotoClientePreviewUrl = url;
      } catch (error) {
        this.fotoClientePreviewUrl = "";
      }
    },

    async guardarFotoClienteSiExiste(idCliente) {
      if (!this.fotoClienteFile || !idCliente) {
        return;
      }

      const formData = new FormData();
      formData.append("idCliente", idCliente);
      formData.append("foto", this.fotoClienteFile);

      const response = await fetch(`${process.env.VUE_APP_API_URL}/admin/clientes/foto`, {
        method: "POST",
        body: formData,
        headers: {
          Authorization: `Bearer ${store.token}`,
        },
      });

      const data = await response.json();
      if (!response.ok || data.error) {
        throw new Error(data.message || "No se pudo guardar la foto cliente");
      }
    },

    formatInput() {
      // Elimina todos los guiones existentes en el valor actual
      const cleanedValue = this.dni.replace(/-/g, "");

      // Aplica el formato con guiones
      let formattedValue = "";
      for (let i = 0; i < cleanedValue.length; i++) {
        if (i === 4 || i === 8) {
          formattedValue += "-";
        }
        formattedValue += cleanedValue[i];
      }

      // Actualiza el valor del input
      this.dni = formattedValue;
    },
    goBack() {
      this.$router.go(-1); // Navegar a la página anterior
    },

  },
  

};
</script>

<style scoped>

.btn{
  padding: 8px;
}

.dashboard-shell {
  background: linear-gradient(165deg, #f5f7fb 0%, #eef1f7 45%, #f8fafc 100%);
  min-height: 100vh;
}

.cardplay {
  border-radius: 24px;
  border: none !important;
  padding: 24px;
  background-color: #ffffff;
  box-shadow: 0 24px 60px rgba(15, 23, 42, 0.08);
}

.solicitud-card-body {
  padding: 0;
}

.dashboard-header {
  background: linear-gradient(120deg, #111827 0%, #1f2937 70%, #374151 100%);
  border-radius: 18px;
  color: #fff;
  padding: 14px 16px;
}

.dashboard-title {
  color: #fff;
  font-weight: 700;
  letter-spacing: 0.4px;
  font-size: 1.35rem;
}

.solicitud-subtitle {
  color: #e5e7eb;
  font-size: 0.95rem;
}

.solicitud-badge {
  display: inline-block;
  border: 1px solid #e5e7eb66;
  border-radius: 999px;
  padding: 0.3rem 0.75rem;
  color: #f9fafb;
  font-size: 0.85rem;
}

.solicitud-main-btn {
  border-radius: 999px;
  font-weight: 600;
}

.datos-personales-row {
  align-items: flex-start;
}

.foto-cliente-field {
  border: 1px solid #e5e7eb;
  border-radius: 14px;
  padding: 12px 8px;
  background: #f8fafc;
}

.foto-cliente-preview {
  width: 92px;
  height: 92px;
  border-radius: 10px;
  overflow: hidden;
  background: #e5e7eb;
  color: #192230;
  display: flex;
  align-items: center;
  justify-content: center;
  flex: 0 0 auto;
}

.foto-cliente-preview img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.foto-cliente-preview i {
  font-size: 34px;
}

.foto-cliente-actions {
  min-width: 240px;
  max-width: 420px;
}

.foto-cliente-actions small {
  color: #6b7280;
}

.celular-history-btn {
  white-space: nowrap;
  height: 38px;
}

.celular-history-panel {
  margin-top: 8px;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  background: #f8fafc;
  overflow: hidden;
}

.celular-history-empty {
  padding: 10px 12px;
  color: #6b7280;
  font-size: 13px;
}

.celular-history-item {
  padding: 10px 12px;
  border-bottom: 1px solid #e5e7eb;
}

.celular-history-item:last-child {
  border-bottom: 0;
}

.celular-history-date {
  color: #6b7280;
  font-size: 12px;
  margin-bottom: 4px;
}

.celular-history-values {
  display: flex;
  align-items: center;
  gap: 8px;
  color: #111827;
  font-size: 13px;
  overflow-wrap: anywhere;
}

.celular-history-values i {
  color: #6b7280;
  font-size: 11px;
}

.solicitud-accordion {
  border-radius: 18px !important;
}

.solicitud-accordion .accordion-item {
  border: 1px solid #e2e8f0 !important;
  border-radius: 14px !important;
  overflow: hidden !important;
  margin-bottom: 12px !important;
  box-shadow: 0 8px 22px rgba(15, 23, 42, 0.06) !important;
}

.solicitud-accordion .accordion-header {
  border-radius: 14px !important;
}

.solicitud-accordion .accordion-button {
  background: linear-gradient(120deg, #f8fafc 0%, #eef2ff 100%) !important;
  color: #111827 !important;
  font-weight: 700 !important;
  border: none !important;
  box-shadow: none !important;
  padding: 0.9rem 1rem !important;
}

.solicitud-accordion .accordion-button:not(.collapsed) {
  background: linear-gradient(120deg, #111827 0%, #1f2937 100%) !important;
  color: #f9fafb !important;
}

.solicitud-accordion .accordion-button::after {
  filter: grayscale(0.2) contrast(1.2) !important;
}

.solicitud-accordion .accordion-button:not(.collapsed)::after {
  filter: brightness(2.5) !important;
}

.solicitud-accordion .accordion-body {
  background: #ffffff !important;
  padding: 1rem !important;
}

.refStatus.refStatusActive {
  border: 2px solid #248D5D;
  color: #000;
  border-radius: 10px;
  margin: 0;
}

.refStatus.is-invalidRef {
  border: 2px solid #ff0000;
  color: #000;
  border-radius: 10px;
  margin: 0;
}

.ref-content div {
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;

  >input[name="referencia-geografica"] {
    width: 100%;
    padding: 0.875rem 1.375rem;
    font-size: 0.875rem;
    border-radius: 10px;
    border: 1px solid #c9ccd7;
    position: relative;
    padding-right: 110px;
  }
}

.refStatus {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 45px;
  padding: 0.875rem 1.375rem;
  font-size: 0.8rem;
  border-radius: 10px;
  border: 1px solid #c9ccd7;
  position: relative;
  padding-right: 110px;
}

.ver_mas_ref_geo {
  position: absolute;
  top: 0;
  right: 0;
  background-color: #4285f4;
  color: white;
  border-radius: 10px;
  border: none;
  padding: 0;
  margin: 0;
  cursor: pointer;
  width: 100px;
  height: 46px;
  z-index: 10;
}

.card {
  border-radius: 12px;
  border: none !important;
}

.form-control {
  border-radius: 10px;
  height: 70%;
}

.form-control:focus {
  /* border-color: #ff9100; */
  box-shadow: 0px 0px 5px rgba(0, 0, 0, 0.1);
  /* Sombra */
}

.col-form-label {
  margin: 0px !important;
}

.form-group {
  margin-bottom: 0px;
}

.form-group {
  margin-block: 8px;
}

.col-form-label {
  padding-left: 10px;
  padding-right: 5px;
}

.card-description {
  margin-block: 15px;
}

.form-control {
  color: #4a4a4a !important;
}

.btnn {
  /* background-color: aqua; */
  border-radius: 50px;
  width: 50px;
  height: 50px;
}

.btnn p {
  margin-bottom: 0px;
  color: white;
}
</style>

<style>
.form-control {
  border-radius: 10px;
  height: 70%;
}

.carta {
  border-radius: 12px;
  /* border-left-color: #4285f4; */
  /* border-top: 5px solid #00ff0d88; */
  /* border-left: 5px solid #ffea0667; */
}

.fm {
  border-radius: 10px;
  height: 70%;
}

.fm:focus {
  /* border-color: #ff9100; */
  box-shadow: 0px 0px 5px rgba(0, 0, 0, 0.1);
  /* Sombra */
}

.pad {
  /* padding-left: 5px; */
  padding-inline: 5px !important;
}


.ownModal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  /* background-color: rgba(0, 0, 0, 0.5); */
  z-index: 10000;
  transform: translate(500%, 500%);

  >.ownModalContent {
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(500%, 500%);
    background-color: white;
    width: 80%;
    height: 95%;
    border-radius: 10px;
    z-index: 10002;
    padding: 10px;

    /* box-shadow: 0px 0px 5px rgba(0, 0, 0, 0.1); */
    /* Sombra */
    >h1 {
      text-align: center;
    }
  }

  >.ownModalBack {
    transform: translate(500%, 500%);
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    z-index: 10001;
  }
}

.ownModal.ownModalActive {

  transform: translate(0%, 0%) scale(1);

  >.ownModalContent {
    transform: translate(-50%, -50%) scale(1);
  }

  >.ownModalBack {
    transform: translate(0%, 0%);
  }
}

label {
  font-weight: 500;
}


</style>

<style scoped>
.row > * {

    margin-block: 5px !important;
}
</style>
